import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_WIDTH_HEADER_CONVERTER_TOKEN, FullWidthHeaderConverter } from './full-width-header.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthHeaderFeature: {
          module: () => import('./full-width-header.module').then((m) => m.FullWidthHeaderModule),
          cmsComponents: ['full_width_header'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_HEADER_CONVERTER_TOKEN,
      useExisting: FullWidthHeaderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_header: FULL_WIDTH_HEADER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthHeaderFeatureModule {}
